module.exports = __webpack_public_path__ + "static/media/info-image1.3ae6583c.svg";